import React from 'react';
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';

function TranscriptInput({ transcript, setTranscript }) {
  const modules = {
    toolbar: [
      ['bold', 'italic', 'underline'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }],
      [{ 'size': ['small', false, 'large', 'huge'] }],
      [{ 'color': [] }],
      ['clean']
    ],
  };

  const formats = [
    'bold', 'italic', 'underline',
    'list', 'bullet',
    'size',
    'color',
  ];

  return (
    <div className="transcript-input">
      <label htmlFor="transcript">Paste Your Transcript</label>
      <ReactQuill 
        theme="snow"
        value={transcript}
        onChange={setTranscript}
        modules={modules}
        formats={formats}
        bounds={'.app'}
        placeholder="Start typing your transcript here..."
      />
    </div>
  );
}

export default TranscriptInput;
